<h2 class="text-center" mat-dialog-title>Exporteer PDF</h2>
<mat-dialog-content>
    <div class="pt-2">
        <div>
            <mat-checkbox [formControl]="fcOnlyWeekTotals">Toon alleen weektotalen</mat-checkbox>
        </div>
        <div>
            <mat-checkbox [formControl]="fcNoHours">Verberg alle uren</mat-checkbox>
        </div>
        <div>
            <mat-checkbox [formControl]="fcNoComments">Verberg commentaren</mat-checkbox>
        </div>
        <div>
            <mat-checkbox [formControl]="fcNoAsphalt">Verberg asfalt</mat-checkbox>
        </div>
        @if (Functionalities.CommonHourCheck | hasFunctionality) {
            <div>
                <mat-checkbox [formControl]="fcNoCars">Verberg personenauto's</mat-checkbox>
            </div>
        }
    </div>
</mat-dialog-content>
<mat-dialog-actions class="justify-content-between">
    <button class="planning-button cancel" [disabled]="downloadingPdf" (click)="cancel()" mat-raised-button>
        Annuleren
    </button>
    <button
        class="planning-button confirm"
        [disabled]="downloadingPdf"
        (click)="pdf()"
        mat-raised-button
        color="primary">
        PDF maken
        @if (downloadingPdf) {
            <i class="fas fa-spinner fa-spin"></i>
        }
    </button>
</mat-dialog-actions>
